import { LegalAdAuctionDTO } from "./legalAdAuctionDTO";

export class LegalAdDTO{

    public id!:number;
    public state!:string;
    public county!:string;
    public countyId!:number;
    public documentReference!:string;
    public createdAt!:string;
    public createdByUser!:string;
    public submittedAt?:string;
    public submittedByUser?:string;
    public submittedManual:boolean = false;
    public submittedTo?:string;
    public confirmedAt?:string;
    public confirmedByUser?:string;
    public publishingDatesCount?:number;
    public publishingDates?:string[];
    public legalAdAuctions?:LegalAdAuctionDTO[];

    constructor(){
    }
}